<template>
  <div class="overflow-hidden">
    <div class="p-6 lg:p-10">
      <div class="w-full h-[130px] lg:h-[260px] overflow-hidden shadow-overlap flex-none mb-6">
        <NuxtImg
          ref="thumbnail"
          v-if="thumbnail && domainId"
          src="/images/card-thumbnail-default.jpg"
          :srcset="thumbnail"
          :alt="$filters.label(domainId, 'domaines')?.toString()"
          class="w-full h-full object-cover"
          width="200"
          height="130"
          loading="lazy"
          @error="onImgError"
        />
      </div>
      <div class="flex flex-wrap gap-2 min-w-0 mb-6">
        <DsfrTag size="md"> {{ domaine.name }} </DsfrTag>
        <DsfrTag v-if="domaineSecondary" size="md">
          {{ domaineSecondary.name }}
        </DsfrTag>
      </div>
      <div class="text-[22px] font-bold leading-7 mb-4">{{ mission.name }}</div>
      <div class="">
        <DsfrLink :to="mission.full_url" :is-external="true" class="text-jva-blue-500"
          >Ouvrir la mission</DsfrLink
        >
      </div>
      <hr class="my-6" />
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-6">
        <div>
          <div class="mb-2 uppercase text-[#666666] text-xs font-bold">Organisation</div>
          <div class="font-bold text-[#161616]">
            {{ mission.structure.name }}
          </div>
        </div>
        <div>
          <div class="mb-2 uppercase text-[#666666] text-xs font-bold">Lieu</div>
          <div class="font-bold text-[#161616]">
            <template v-if="mission.type === 'Mission en présentiel' && mission.addresses">
              {{ uniqueCities.join(', ') }}
            </template>
            <template v-else-if="mission.type === 'Mission à distance'">
              Mission à distance
            </template>
            <template v-else>À définir</template>
          </div>
        </div>
        <div>
          <div class="mb-2 uppercase text-[#666666] text-xs font-bold">Durée et date</div>
          <div class="font-bold text-[#161616]">
            <template v-if="hasExpired">{{ formattedCommitment }} - Liste d'attente</template>
            <template v-else-if="hasDates"
              >{{ formattedCommitment }} •
              {{
                nextDates
                  .slice(0, 3)
                  .map((date) => $dayjs(date.id).format('D MMM'))
                  .join(', ')
              }}</template
            >
            <template v-else-if="isOngoingWithNoEndDate">
              {{ formattedCommitment }} • Dès maintenant</template
            >
            <template v-else=""> {{ formattedCommitment }} • {{ formattedDates }}</template>
          </div>
        </div>
        <div class="">
          <div class="mb-2 uppercase text-[#666666] text-xs font-bold">Activités</div>
          <div class="flex flex-wrap gap-2">
            <DsfrBadge v-for="activity in activities" :key="activity.id">
              {{ activity.name }}
            </DsfrBadge>
          </div>
        </div>
      </div>
      <div class="border p-6">
        <div class="flex flex-col lg:flex-row lg:items-center lg:justify-start gap-4 sm:gap-6">
          <img
            src="/images/missions/prerequisites.svg"
            alt="Pré-requis"
            class="flex-none w-[48px]"
          />
          <div class="w-full sm:w-auto">
            <template v-if="hasPrerequisites">
              <div class="uppercase text-[#666666] text-xs font-bold mb-2">Pré-requis</div>
              <ol
                :class="[
                  'text-[#3A3A3A] hyphens-auto',
                  { 'list-decimal pl-6': mission.prerequisites.length > 1 },
                ]"
              >
                <li
                  v-for="(prerequisite, key) in mission.prerequisites.filter((p) => p)"
                  :key="key"
                >
                  {{ prerequisite }}
                </li>
              </ol>
            </template>
            <template v-else>
              <div class="text-[#666666] text-sm">
                Le responsable n’a pas spécifié de pré-requis pour participer à cette mission.
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MixinMission from '@/mixins/mission'

export default defineNuxtComponent({
  mixins: [MixinMission],
  data() {
    return {}
  },
  props: {
    mission: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hasPrerequisites() {
      return this.mission.prerequisites?.filter((p) => p).length > 0
    },
  },
  methods: {},
})
</script>
